(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1170],{

/***/ 2465:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-course-license",
      function () {
        return __webpack_require__(57379);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84649:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { de: common  } = __webpack_require__(31668);
module.exports = {
    ...common
};


/***/ }),

/***/ 56973:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
const { en: common  } = __webpack_require__(31668);
module.exports = {
    ...common,
    "free-course-license-page": __webpack_require__(16004)
};


/***/ }),

/***/ 36416:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* eslint-disable global-require */ 
module.exports = {
    en: __webpack_require__(56973),
    de: __webpack_require__(84649)
};


/***/ }),

/***/ 57379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85786);
/* harmony import */ var _insightfulscience_atomic_react_Hero__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69591);
/* harmony import */ var _insightfulscience_atomic_react_Hero_Title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91319);
/* harmony import */ var _insightfulscience_atomic_react_Hero_Action__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14593);
/* harmony import */ var _insightfulscience_atomic_react_Hero_ButtonLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85765);
/* harmony import */ var _insightfulscience_smart_react_PageMeta__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93890);
/* harmony import */ var _insightfulscience_i18__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46003);
/* harmony import */ var _insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35449);
/* harmony import */ var _insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67478);
/* harmony import */ var _insightfulscience_atomic_react_Heading__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42866);
/* harmony import */ var _insightfulscience_shared_utils_fn_pipe__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75833);
/* harmony import */ var _src_config__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89032);
/* harmony import */ var _src_utils_hubspotForm__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(95905);
/* harmony import */ var _src_SiteLayout__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(3918);
/* harmony import */ var _locales_free_course_license_page__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(36416);
/* harmony import */ var _locales_free_course_license_page__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_locales_free_course_license_page__WEBPACK_IMPORTED_MODULE_16__);

















const FreeCourseLicense = ()=>{
    const [t] = (0,_insightfulscience_i18__WEBPACK_IMPORTED_MODULE_8__/* .useLocale */ .bU)("free-course-license-page");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_src_SiteLayout__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
            hero: true,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_smart_react_PageMeta__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    title: t("PAGE_TITLE"),
                    description: t("META_DESCRIPTION"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_PageMeta__WEBPACK_IMPORTED_MODULE_7__/* ["default"].OGP */ .ZP.OGP, {
                            title: t("PAGE_TITLE"),
                            description: t("META_DESCRIPTION"),
                            locale: t("META_LOCALE"),
                            type: t("META_TYPE"),
                            url: t("META_URL"),
                            image: t("META_IMAGE"),
                            imageSecureUrl: t("META_IMAGE_SECURE"),
                            siteName: t("META_SITE_NAME"),
                            articlePublisher: t("META_ARTICLE_PUBLISHER"),
                            isImageBaseUrl: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_PageMeta__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Twitter */ .ZP.Twitter, {
                            title: t("PAGE_TITLE"),
                            description: t("META_DESCRIPTION"),
                            site: t("META_TWITTER_SITE"),
                            card: t("META_TWITTER_CARD"),
                            image: t("META_TWITTER_IMAGE"),
                            creator: t("META_TWITTER_CREATOR"),
                            isImageBaseUrl: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_PageMeta__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Canonical */ .ZP.Canonical, {
                            href: t("META_CANONICAL")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_smart_react_PageMeta__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Author */ .ZP.Author, {
                            content: t("META_AUTHOR")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Hero__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Hero_Title__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            children: t("HERO_TITLE")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Hero_Action__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Hero_ButtonLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                href: "#hubspotFormWrapper",
                                children: t("HERO_LINK")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseContainer */ .RH, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseHeader */ .o$, {
                            children: t("STUDENT_TITLE")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseSubtitle */ .ab, {
                            children: t("STUDENT_SUBTITLE")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseContentWrapper */ .jK, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseContentImage */ .NG, {
                            src: "/images/snapgene/free-course-license/rectangle.png"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseContentListWrapper */ .MZ, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseContentListItem */ .T, {
                                    children: t("STUDENT_LIST_ITEM_1")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseContentListItem */ .T, {
                                    children: t("STUDENT_LIST_ITEM_2")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseContentListItem */ .T, {
                                    children: t("STUDENT_LIST_ITEM_3")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseContentListItem */ .T, {
                                    children: t("STUDENT_LIST_ITEM_4")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseContentListItem */ .T, {
                                    children: t("STUDENT_LIST_ITEM_5")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseContentListItem */ .T, {
                                    children: t("STUDENT_LIST_ITEM_6")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "hubspotFormWrapper",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        utility: {
                            bgColor: "white"
                        },
                        cellWidth: 9,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_10__/* .Row */ .X2, {
                                utility: {
                                    justify: "center"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Grid__WEBPACK_IMPORTED_MODULE_10__/* .Col */ .JX, {
                                    sm: 12,
                                    md: 7,
                                    spacing: {
                                        mb: 10
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Heading__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        Tag: "h3",
                                        sx: {
                                            fontSize: "l",
                                            fontWeight: "normal",
                                            textAlign: "center"
                                        },
                                        children: "Bring the power of SnapGene to your classroom"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_utils_hubspotForm__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                id: "hubspotFreeCourseForm",
                                formId: _src_config__WEBPACK_IMPORTED_MODULE_13__/* .publicConfig.HUBSPOT_FREE_COURSE_LICENSE_FORM_ID */ .mn.HUBSPOT_FREE_COURSE_LICENSE_FORM_ID
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseFAQContainer */ .ar, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseHeader */ .o$, {
                            children: t("FAQ_TITLE")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseFAQItemWrapper */ .$$, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseFAQItemHeader */ .qs, {
                                    children: t("FAQ_QUESTION_1")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseFAQItemContent */ .ZY, {
                                    children: t("FAQ_ANSWER_1")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseFAQItemWrapper */ .$$, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseFAQItemHeader */ .qs, {
                                    children: t("FAQ_QUESTION_2")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseFAQItemContent */ .ZY, {
                                    children: t("FAQ_ANSWER_2")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseFAQItemWrapper */ .$$, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseFAQItemHeader */ .qs, {
                                    children: t("FAQ_QUESTION_3")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseFAQItemContent */ .ZY, {
                                    children: t("FAQ_ANSWER_3")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseFAQItemWrapper */ .$$, {
                            line: false,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseFAQItemHeader */ .qs, {
                                    children: t("FAQ_QUESTION_4")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r1_molecules_FreeCourseLicense__WEBPACK_IMPORTED_MODULE_2__/* .FreeCourseLicenseFAQItemContent */ .ZY, {
                                    children: t("FAQ_ANSWER_4")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = ((0,_insightfulscience_shared_utils_fn_pipe__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(FreeCourseLicense, (0,_insightfulscience_i18__WEBPACK_IMPORTED_MODULE_8__/* .WithLocale */ ._t)({
    resources: (_locales_free_course_license_page__WEBPACK_IMPORTED_MODULE_16___default())
})));


/***/ }),

/***/ 95905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89032);




const HubspotForm = (param)=>{
    let { id , formId  } = param;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const hubspotFormCreate = ()=>{
            // eslint-disable-next-line no-undef
            hbspt.forms.create({
                portalId: "".concat(_config__WEBPACK_IMPORTED_MODULE_2__/* .publicConfig.HUBSPOT_PORTAL_ID */ .mn.HUBSPOT_PORTAL_ID),
                formId,
                region: "na1",
                target: "#".concat(id)
            });
        };
        if (!document.getElementById("hubspot_script")) {
            const hubSpotScript = document.createElement("script");
            hubSpotScript.id = "hubspot_script";
            hubSpotScript.type = "text/javascript";
            hubSpotScript.src = "//js.hsforms.net/forms/v2.js";
            hubSpotScript.async = true;
            document.body.appendChild(hubSpotScript);
            hubSpotScript.onload = ()=>{
                hubspotFormCreate();
            };
        } else {
            hubspotFormCreate();
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        id: id
    });
};
HubspotForm.propTypes = {
    id: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired,
    formId: prop_types__WEBPACK_IMPORTED_MODULE_3__.string.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (HubspotForm);


/***/ }),

/***/ 16004:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"META_TITLE":"Free Course License - SnapGene","META_DESCRIPTION":"The students of today will discover the scientific breakthroughs of tomorrow. We want to help. We offer free licenses to educators for their students using SnapGene in their course. Help...","META_ARTICLE_PUBLISHER":"https://www.facebook.com/SnapGene","META_AUTHOR":"GSL Biotech LLC","META_SITE_NAME":"SnapGene","META_LOCALE":"en_US","META_TYPE":"article","META_IMAGE":"/images/snapgene/meta/preview-snapgene-dotmatics.png","META_IMAGE_SECURE":"/images/snapgene/meta/preview-snapgene-dotmatics.png","META_TWITTER_SITE":"@SnapGene","META_TWITTER_CARD":"summary_large_image","META_TWITTER_CREATOR":"@SnapGene","META_TWITTER_IMAGE":"/images/snapgene/meta/preview-snapgene-dotmatics.png","META_URL":"https://www.snapgene.com/free-course-license","META_CANONICAL":"https://www.snapgene.com/free-course-license","PAGE_TITLE":"Free Course License - SnapGene","HERO_TITLE":"Get Free Course Licenses for Your Students","HERO_LINK":"Bring SnapGene to Your Classroom","STUDENT_TITLE":"The students of today will discover the scientific breakthroughs of tomorrow.","STUDENT_SUBTITLE":"We want to help. We offer free licenses to educators for their students using SnapGene in their course.","STUDENT_LIST_ITEM_1":"Help your students perform DNA manipulations","STUDENT_LIST_ITEM_2":"Accelerate learning with SnapGene’s intuitive interface","STUDENT_LIST_ITEM_3":"Enable students to clone accurately","STUDENT_LIST_ITEM_4":"Enhance collaboration by sharing SnapGene annotated maps and sequences","STUDENT_LIST_ITEM_5":"Licenses available for student’s personal computers","STUDENT_LIST_ITEM_6":"Plus it’s easy to get for your course and completely free!","FAQ_TITLE":"FAQ","FAQ_QUESTION_1":"What is a SnapGene free course license?","FAQ_ANSWER_1":"We offer free licenses to students to use SnapGene in courses. The free course licenses are activated during the duration of the course and are available for students only. Once the course ends, the free course licenses expire.","FAQ_QUESTION_2":"What types of courses qualify for a free course license request?","FAQ_ANSWER_2":"  Course offerings for undergrad courses of accredited universities and high schools. Courses must not exceed a 6 month period. Not all courses are eligible. Submissions are subject to review.","FAQ_QUESTION_3":"Who can request free course licenses?","FAQ_ANSWER_3":"Only course instructors can request free course licenses on behalf of their students. In order to be eligible for a course license, the course instructor(s) must have an active SnapGene subscription.","FAQ_QUESTION_4":"Who can use the free course licenses?","FAQ_ANSWER_4":" Only students can use SnapGene free course licenses. Free course licenses will not be given to instructors. If we suspect misuse of this license, we reserve the right to suspend access."}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6319,5606,8124,6016,2458,3918,9774,2888,179], function() { return __webpack_exec__(25436), __webpack_exec__(2465); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);